export const MAX_CHAR_LENGTH = 'MAX Characters allowed  35';
export const MAX_STATE_LENGTH = 'MAX Characters allowed 2';
export const MAX_ZIP_CODE_LENGTH = 'Zip Code must be between 5-9 characters';
export const MAX_PHONE_NUMBER_LENGTH = 'MAX Characters allowed 10';
export const MRN_NO_MATCH = "MRN doesn't match";
export const REQUIRED_MESSAGE = 'required';
